import Fuse from 'fuse.js';
import { CachedSearchedMarketsType } from 'src/interfaces/idashboard';


class MarketSearch {
  private markets: CachedSearchedMarketsType[];
  private fuse: Fuse<CachedSearchedMarketsType>;

  constructor(cachedSearchMarkets: {
    markets: CachedSearchedMarketsType[];
    fuse: Fuse<CachedSearchedMarketsType>;
  }) {
    this.markets = cachedSearchMarkets.markets;
    this.fuse = cachedSearchMarkets.fuse;
    return this;
  }

  getPriority(market: CachedSearchedMarketsType) {
    if (market) {
      return market.priority.charCodeAt(0);
    }
    return 'f'.charCodeAt(0);
  }

  calculate(input: string) {
    if (!input || input.trim() === '') {
      return [];
    }

    let finalResult: CachedSearchedMarketsType[] = [];
    const inputValueBreakDownArray: string[] = input.includes(',')
      ? [input, ...input.split(',').map(currentSpitedInputPart => currentSpitedInputPart.trim())]
      : [input];

    for (const currentInputChunk of inputValueBreakDownArray) {
      const results: CachedSearchedMarketsType[] = this.fuse.search(currentInputChunk, {limit: 7}).map(data => data.item);
      const top7Results = results.slice(0, 7);

      finalResult = [...finalResult, ...top7Results];
    }
    // return finalResult; 
    return this.sortSearchResults(finalResult, inputValueBreakDownArray).slice(0, 11);
  }

  formatSearchBarListingNames(district: string, city: string, country: string){
    if (!district) return '';

    let result = district;
    if (city && city != '0') {
      result += ', ' + city;
    }
    result += ` ( ${country} )`;
    return result;
  };

  getExactMatches(searchResults: CachedSearchedMarketsType[], inputs: string[], seenSearchNames: Set<string>){
    const results: CachedSearchedMarketsType[] = [];
   
    searchResults.forEach((searchResult) => {
      const searchName = this.formatSearchBarListingNames(searchResult.district, searchResult.city, searchResult.country);      

      inputs.forEach((input) => {
        if (
          !seenSearchNames.has(searchName) && 
          (
            searchName.slice(0, input.length).toLowerCase() == input.toLowerCase() ||
            searchName.slice(0, input.length).toLowerCase().replace(/,/gi, "") == input.toLowerCase()
          )
        ) {
          results.push(searchResult);
          seenSearchNames.add(searchName);
        }
      })
    })
    
    return results;
  }

  getPartialMatchs(searchResults: CachedSearchedMarketsType[], inputs: string[], seenSearchNames: Set<string>){
    const results: CachedSearchedMarketsType[] = [];
   
    searchResults.forEach((searchResult) => {
      const searchName = this.formatSearchBarListingNames(searchResult.district, searchResult.city, searchResult.country);

      inputs.forEach((input) => {
        if (
          !seenSearchNames.has(searchName) && 
          searchName.search(new RegExp(input, 'ig')) > -1
        ) {
          results.push(searchResult);
          seenSearchNames.add(searchName);
        }
      })
    })
    
    return results;
  }

  compareResults(result1: CachedSearchedMarketsType, result2: CachedSearchedMarketsType){
    // Compare by priority
    const priorityComparison = result1.priority.localeCompare(result2.priority);
  
    // If priorities are the same, compare by isVerified
    if (priorityComparison === 0) {
      // +true = 1, +false = 0
        const verifiedComparison = +result2.isVerified - +result1.isVerified;
  
        // If isVerified is the same, compare by lexical order of searchName
        return verifiedComparison === 0
            ? result1.district.localeCompare(result2.district)
            : verifiedComparison;

    }
  
    return priorityComparison;
  };

  sortSearchResults(searchResults:  CachedSearchedMarketsType[], inputTextArr: string[], districtOnly=true) {

    let exactMatches:  CachedSearchedMarketsType[] = [];
    let partialMatches:  CachedSearchedMarketsType[] = [];
    let nonMatches:  CachedSearchedMarketsType[] = [];
  
    const seenSearchNames = new Set<string>();
      
    exactMatches = this.getExactMatches(searchResults, inputTextArr.slice(0, 2), seenSearchNames);
    partialMatches = this.getPartialMatchs(searchResults, inputTextArr, seenSearchNames);
  
    nonMatches = searchResults.filter((searchResult) => {
      const searchName = this.formatSearchBarListingNames(searchResult.district, searchResult.city, searchResult.country);
      if(!seenSearchNames.has(searchName)){
        seenSearchNames.add(searchName);
        return true;
      }
      return false;
    })
    
    exactMatches = exactMatches.sort(this.compareResults);
    partialMatches = partialMatches.sort(this.compareResults);
    nonMatches = nonMatches.sort(this.compareResults);
  
    return [...exactMatches, ...partialMatches, ...nonMatches];
  };
}

export default MarketSearch;
